import React, { useEffect, useState } from 'react';

const AD_SIZES = {
  'ad-editor-sidebar':        { width: '100%', height: '120px' },
  'ad-editor-sidebar-left-1': { width: '100%', height: '120px' },
  'ad-editor-sidebar-left-2': { width: '100%', height: '120px' },
  'ad-editor-sidebar-full':   { width: '100%', height: '300px' },
  'ad-editor-sidebar-right':  { width: '100%', height: '300px' },
  'ad-editor-top':            { width: '600px', height: '90px' },
  'ad-home-hero':             { width: '100%', height: '90px' },
  'ad-home-pricing':          { width: '100%', height: '90px' },
  'ad-pdf-download':          { width: '100%', height: '120px' },
};

// CTAs maison par slot
const FALLBACK_CTA = {
  'ad-editor-top': {
    bg: '#1a1a1a',
    border: '1px solid #FF0066',
    text: '🚀 Passez au Plan Agence — Logo personnalisé, sans pub, multi-comptes',
    cta: 'Découvrir →',
    url: '/tarifs',
    layout: 'horizontal',
  },
  'ad-editor-sidebar-left-1': {
    bg: 'linear-gradient(135deg, #1a1a1a, #2a2a2a)',
    border: '1px solid #333',
    text: 'Votre pub ici',
    sub: 'Audience 100% mannequins & castings',
    cta: 'contact@compify.fr',
    url: '/contact',
    layout: 'vertical',
  },
  'ad-editor-sidebar-left-2': {
    bg: 'linear-gradient(135deg, #FF0066, #cc0052)',
    border: 'none',
    text: 'Plan Agence',
    sub: '49,99€/mois — Sans pub, logo perso',
    cta: 'En savoir plus →',
    url: '/tarifs',
    layout: 'vertical',
  },
  'ad-editor-sidebar-right': {
    bg: 'linear-gradient(135deg, #1a1a1a, #2a2a2a)',
    border: '1px solid #333',
    text: 'Votre pub ici',
    sub: 'Vue par des mannequins actifs chaque jour',
    cta: 'Nous contacter →',
    url: '/contact',
    layout: 'vertical',
  },
  'ad-home-hero': {
    bg: '#1a1a1a',
    border: '1px solid #FF0066',
    text: '✦ Plan Agence — Gérez tous vos mannequins depuis un seul compte',
    cta: 'Voir le plan →',
    url: '/tarifs',
    layout: 'horizontal',
  },
  'ad-home-pricing': {
    bg: '#1a1a1a',
    border: '1px solid #333',
    text: '📩 Vous êtes annonceur ? Touchez une audience qualifiée de mannequins et castings.',
    cta: 'Contactez-nous →',
    url: '/contact',
    layout: 'horizontal',
  },
  'ad-pdf-download': {
    bg: 'linear-gradient(135deg, #FF0066, #cc0052)',
    border: 'none',
    text: 'Partagez Compify à un ami mannequin 🙌',
    sub: 'C\'est gratuit, ça prend 30 secondes.',
    cta: 'compify.fr',
    url: '/',
    layout: 'vertical',
  },
};

function FallbackCTA({ slotId, size }) {
  const cta = FALLBACK_CTA[slotId];
  if (!cta) return <div style={{ width: size.width, height: size.height }} />;

  const handleClick = () => {
    if (cta.url.startsWith('/')) {
      window.location.href = cta.url;
    } else {
      window.open(cta.url, '_blank', 'noopener,noreferrer');
    }
  };

  if (cta.layout === 'horizontal') {
    return (
      <div
        onClick={handleClick}
        style={{
          width: size.width, height: size.height,
          background: cta.bg,
          border: cta.border,
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 20px',
          cursor: 'pointer',
          gap: '12px',
          boxSizing: 'border-box',
        }}
      >
        <span style={{ fontSize: '12px', color: '#fff', letterSpacing: '0.3px', flex: 1 }}>
          {cta.text}
        </span>
        <span style={{
          fontSize: '11px', color: '#FF0066', fontWeight: '700',
          letterSpacing: '1px', whiteSpace: 'nowrap',
          border: '1px solid #FF0066', padding: '4px 10px', borderRadius: '2px',
        }}>
          {cta.cta}
        </span>
      </div>
    );
  }

  // layout vertical
  return (
    <div
      onClick={handleClick}
      style={{
        width: size.width, height: size.height,
        background: cta.bg,
        border: cta.border,
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px',
        cursor: 'pointer',
        gap: '4px',
        boxSizing: 'border-box',
        textAlign: 'center',
      }}
    >
      <span style={{ fontSize: '11px', color: '#fff', fontWeight: '700', letterSpacing: '0.5px' }}>
        {cta.text}
      </span>
      {cta.sub && (
        <span style={{ fontSize: '10px', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.3px' }}>
          {cta.sub}
        </span>
      )}
      <span style={{
        fontSize: '10px', color: '#FF0066', fontWeight: '700',
        letterSpacing: '1px', marginTop: '4px',
      }}>
        {cta.cta}
      </span>
    </div>
  );
}

export default function AdSlot({ id }) {
  
  const size = AD_SIZES[id];
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetch('/api/ad-config')
      .then(res => res.json())
      .then(data => setConfig(data[id] || { active: false, debug: false }))
      .catch(() => setConfig({ active: false, debug: false }));
  }, [id]);

  if (!size) return null;
  if (!config) return <FallbackCTA slotId={id} size={size} />;

  // Mode debug
  if (config.debug) return (
    <div style={{
      width: size.width, height: size.height,
      backgroundColor: 'rgba(255,0,102,0.06)',
      border: '1px dashed rgba(255,0,102,0.3)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: '4px',
      cursor: config.url ? 'pointer' : 'default'
    }}
      onClick={() => { if (config.url) { const u = config.url.startsWith('http') ? config.url : `https://${config.url}`; window.open(u, '_blank', 'noopener,noreferrer'); }}}
    >
      <span style={{ fontSize: '9px', color: '#FF0066', letterSpacing: '2px', fontWeight: '700' }}>AD SLOT {config.active ? '● ACTIF' : '○ INACTIF'}</span>
      <span style={{ fontSize: '9px', color: '#aaa', letterSpacing: '1px' }}>{id}</span>
      <span style={{ fontSize: '9px', color: '#ccc' }}>{size.width} × {size.height}</span>
    </div>
  );

  // Slot actif avec image annonceur
  if (config.active && config.image) return (
    <div style={{ width: size.width, height: size.height, cursor: config.url ? 'pointer' : 'default', overflow: 'hidden' }}
      onClick={() => { if (config.url) { const u = config.url.startsWith('http') ? config.url : `https://${config.url}`; window.open(u, '_blank', 'noopener,noreferrer'); }}}>
      <img src={config.image} alt="pub" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
    </div>
  );

  // Pas d'annonceur → CTA maison
  return <FallbackCTA slotId={id} size={size} />;
}